import avo from 'analytics/avo';
import { useCallback } from 'react';
import { logError } from 'commons/logger';

const getEventData = ({
  sku,
  product,
  price,
  optionPrice,
  filter,
  color,
  sort,
  location,
}) => ({
  sku,
  upholstery_sort: sort,
  upholstery_filter: color ? `color: ${color}` : filter,
  product_id: product?.id,
  product_name: product?.name,
  product_type: product?.type?.name,
  product_family: product?.family?.name,
  price: price?.final_price ?? 0 + optionPrice,
  full_price: price?.original_price ?? 0 + optionPrice,
  location,
});

const useUpholsteryFilteredEvent = (
  basicDetails,
  optionData,
  priceData,
  location
) => {
  const upholsteryFilteredEvent = useCallback(
    (filter, color, sort) => {
      try {
        const eventData = getEventData({
          filter,
          sort,
          color,
          product: basicDetails,
          price: priceData?.price,
          optionPrice: priceData?.optionPrice,
          options: optionData?.options,
          selectedOptions: optionData?.selectedOptions,
          sku: `${basicDetails?.sku ||
            ''}${optionData?.selectedOptionsVariantSku || ''}`,
          location,
        });

        if (avo && typeof avo.upholsteryFiltered === 'function') {
          avo.upholsteryFiltered({
            fullPrice: parseFloat(eventData?.full_price),
            price: parseFloat(eventData?.price),
            productFamily: eventData?.product_family || '',
            productId: eventData?.product_id || 0,
            upholsteryFilter: eventData?.upholstery_filter,
            upholsterySort: eventData?.upholstery_sort,
            name: eventData?.product_name || '',
            category: eventData?.product_type || '',
            location,
          });
        }
      } catch (error) {
        logError('Error in upholsteryFilteredEvent:', error);
      }
    },
    [basicDetails, optionData, priceData, location]
  );

  return {
    upholsteryFilteredEvent,
  };
};

export default useUpholsteryFilteredEvent;
